import { createSlice } from '../../core';
import type { Point2D } from '../../core/utils';

type RectangleSelectionState = {
  isActive: boolean;
  startPoint: Point2D | null;
  currentPoint: Point2D | null;
};
export type RectangleSelectionSlice = {
  rectangleSelection: {
    state: RectangleSelectionState;
    actions: {
      setState: (state: RectangleSelectionState) => void;
    };
  };
};

export const createRectangleSelectionSlice = createSlice<
  Record<string, never>
>()<RectangleSelectionSlice>(set => ({
  rectangleSelection: {
    state: {
      isActive: false,
      startPoint: null,
      currentPoint: null,
    },
    actions: {
      setState: state =>
        set(root => ({
          ...root,
          rectangleSelection: {
            ...root.rectangleSelection,
            state,
          },
        })),
    },
  },
}));
